import { render } from "./contacts-modal.vue?vue&type=template&id=9fc3f2ac"
import script from "./contacts-modal.vue?vue&type=script&lang=js"
export * from "./contacts-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__